import React, { lazy, useContext, useEffect, useState } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  Typography
} from '@one-thd/sui-atomic-components';
import { Metadata } from '@thd-olt-component-react/metadata';
import { PrivacyHeader } from './PrivacyHeader';
import { PrivacyMetadata } from './PrivacyMetadata';
import FraudCards from './Fraud/FraudCards';
import {
  COMMON_SCAM,
  PAYMENT_FRAUD,
  BRUSHING_SCAMS,
  COMMON_SCAM_TITLE,
  PAYMENT_FRAUD_TITLE,
  BRUSHING_SCAMS_TITLE,
  COMMON_SCAM_IMAGE_RESOURCE,
  PAYMENT_FRAUD_IMAGE_RESOURCE,
  BRUSHING_SCAMS_IMAGE_RESOURCE
} from './constants/Constants';
import './styles/fraudCenter.scss';
import { imageBaseUrl } from '../../constants';

export const FraudCenter = () => {
  const [selectedText, setSelectedText] = useState(COMMON_SCAM_TITLE);
  const [displayText, setDisplayText] = useState(COMMON_SCAM);
  const [imageUri, setImageUri] = useState(COMMON_SCAM_IMAGE_RESOURCE);
  const [cssLoaded, setCssLoaded] = useState(false);
  const { channel } = useContext(ExperienceContext);

  const textMap = [
    { title: COMMON_SCAM_TITLE, text: COMMON_SCAM, imageUri: COMMON_SCAM_IMAGE_RESOURCE },
    { title: PAYMENT_FRAUD_TITLE, text: PAYMENT_FRAUD, imageUri: PAYMENT_FRAUD_IMAGE_RESOURCE },
    { title: BRUSHING_SCAMS_TITLE, text: BRUSHING_SCAMS, imageUri: BRUSHING_SCAMS_IMAGE_RESOURCE },
  ];

  function displayTextToWindow(item) {
    setSelectedText(item.title);
    setDisplayText(item.text);
  }
  function determineMidText(text) {
    const item = textMap.find((obj) => obj.title === text);
    return displayTextToWindow(item);
  }

  function determineImage(text) {
    const item = textMap.find((obj) => obj.title === text);
    setImageUri(item.imageUri);
  }

  useEffect(() => {
    determineMidText(selectedText);
    determineImage(selectedText);
  }, [selectedText]);

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('fraudCenter.static.page-load', {
      pageName: 'privacy and security center>fraud and security',
      pageType: 'content',
      primaryCategory: 'privacy and security center',
      subCategory1: 'privacy and security center>fraud and security',
      subCategory2: 'privacy and security center>fraud and security'
    });
  }, []);

  const metadata = {
    title: 'Fraud Center – The Home Depot',
    description: 'The Fraud Center is designed to help you learn about the information '
      + 'The Home Depot collects and how we use and share it',
    canonical: 'https://www.homedepot.com/privacy/Fraud-Center'
  };

  useEffect(() => {
    lazy(() => import('./styles/fraudCenter.scss'));
    setCssLoaded(true);
  });

  return (cssLoaded
    && (
      <div style={{ backgroundColor: '#F5F5F5' }} className="fraudCenter" data-testid="fraud-center">
        <Metadata>
          <PrivacyMetadata
            title={metadata.title}
            description={metadata.description}
            canonical={metadata.canonical}
          />
        </Metadata>
        <div className="container">
          <QueryProvider cacheKey="customer-data-governance">
            <div className="cdg-content--header">
              <div className="sui-grid sui-gap-4">
                <div>
                  <Breadcrumbs staticCrumbs={[
                    {
                      url: '/privacy/Fraud-Center',
                      label: 'Fraud Center'
                    }]}
                  />
                </div>
              </div>
            </div>
          </QueryProvider>
          <div className="fraud-center--privacy-header">
            <PrivacyHeader fraudCenterActive />
          </div>
          <div className="cdg-content--body">
            <div className="white margin-20 sui-grid sui-gap-4" style={{ 'padding-bottom': '20px' }}>
              <div className="sui-px-4 sui-py-4">
                <div>
                  <Typography variant="h1" weight="bold">Fraud & Security</Typography>
                </div>
              </div>
              {channel === 'desktop' ? (
                <div className="sui-w-screen sui-px-6">
                  <div
                    className="sui-grid sui-grid-cols-1
            sm:sui-grid-cols-1 md:sui-grid-cols-6
            lg:sui-grid-cols-6 xl:sui-grid-cols-6
            2xl:sui-grid-cols-6 sui-gap-3"
                  >
                    <div className="sui-grid sui-span-cols-1">
                      <FraudCards setSelectedText={setSelectedText} />
                    </div>
                    <div className="sui-col-span-3">
                      <Typography variant="h4" weight="bold">
                        {selectedText}
                      </Typography>
                      <Typography variant="body-base">
                        {displayText}
                      </Typography>
                    </div>
                    <div className="sui-col-span-2">
                      <img
                        width="720"
                        height="600"
                        alt="Fraud Center"
                        src={imageBaseUrl + imageUri}
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="sui-w-screen sui-px-6">
                  <div
                    className="sui-grid sui-grid-cols-1
            sm:sui-grid-cols-1 md:sui-grid-cols-6
            lg:sui-grid-cols-6 xl:sui-grid-cols-6
            2xl:sui-grid-cols-6 sui-gap-3"
                  >
                    <div className="sui-grid sui-span-cols-1">
                      <FraudCards setSelectedText={setSelectedText} />
                    </div>
                    <div className="sui-col-span-1">
                      <img
                        width="720"
                        height="600"
                        alt="Fraud Center"
                        src={imageBaseUrl + imageUri}
                        style={{ width: '100%' }}
                      />
                    </div>
                    <div className="sui-col-span-1">
                      <Typography variant="h4" weight="bold">
                        {selectedText}
                      </Typography>
                      <Typography variant="body-base">
                        {displayText}
                      </Typography>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
};
